<template>
  <div>
    <div class="marginCenter">
      <el-form :model="form.applyBasic" :rules="rules" label-position="left" class="form marginTop30">
        <!-- 其他信息 -->
        <div class="marginBom30">
          <div class="fsize24 fcolor_black marginBom18">其他信息</div>
          <div class="content fsize22">进修报到一般在每月第2个工作日，具体以《进修报到通知单》为准。因报到、岗前培训需多部门协作，故请进修人员务必在进修报到日当天报到。</div>
        </div>
        <!-- 进修内容与目标 -->
        <div class="marginBom38 title">
          <el-form-item prop="trainRequest" label="进修内容与目标">
            <el-input class="marginTop24" type="textarea" :rows="2" :maxlength="500" :show-word-limit="true" placeholder="请输入内容" v-model="form.applyBasic.trainRequest"></el-input>
          </el-form-item>
          <!-- <div class="fsize22 fcolor_black marginBom24">进修内容与目标</div>
          <div class="content">
            <el-input type="textarea" :rows="2" placeholder="请输入内容" v-model="form.applyBasic.trainRequest">
            </el-input>
          </div>-->
        </div>
        <!-- 申请进修科室 -->
        <div class="marginBom38">
          <div class="fsize22 contentTitle1 flex-yCenter marginBom24">
            <span class="fcolor_black required">申请进修科室</span>
            <el-button class="btn" type="primary" @click="showAddStudyDept">新增</el-button>
          </div>
          <div class="content">
            <el-table border :data="form.applyDeptList" style="width: 100%">
              <el-table-column prop="train_type" label="科室类型" min-width="150" align="center">
                <span v-if="dict.type.train_type && scope.row.deptType && dict.type.train_type.length > 0" slot-scope="scope">
                  <span>
                    {{ dict.type.train_type.find(item => item.value == scope.row.deptType).label }}
                  </span>
                </span>
              </el-table-column>
              <el-table-column prop="deptName" label="进修科室" min-width="150" align="center">
                <span v-if="deptList" slot-scope="scope">
                  <span>
                    {{ scope.row.deptName }}
                  </span>
                </span>
              </el-table-column>
              <el-table-column prop="beginDate" label="开始时间" min-width="150" align="center"></el-table-column>
              <el-table-column label="进修时长" min-width="130" align="center">
                <span slot-scope="scope">{{ scope.row.trainDuration }}周</span>
              </el-table-column>
              <el-table-column min-width="150" label="操作" align="center">
                <template slot-scope="scope">
                  <div>
                    <el-button type="text" @click="showModifyStudyDept(scope.row)">修改</el-button>
                    <el-button type="text" @click="removeStudyDept(scope.row)">删除</el-button>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
        <div class="overflow staging marginBom30">
          <el-button class="fr blueBtn2 btn300" @click="staging" type="primary">保存此页信息</el-button>
        </div>
        <div class="footer fr flex-yCenter">
          <a class="a backIndex fcolor_blue2 fsize22" @click="goPage(2)">1</a>
          <a class="a backIndex active fcolor_blue2 fsize22" @click="goPage(3)">2</a>
          <a class="a backIndex fcolor_blue2 fsize22" @click="goPage(4)">3</a>
          <a class="a backIndex fcolor_blue2 fsize22" @click="goPage(4)">下一页</a>
        </div>
      </el-form>
    </div>
    <!-- 新增进修科室 -->
    <Modal :showState="addStudyDeptState" @cancel="addStudyDeptCancel" title="新增" @confirm="addStudyDeptConfirm">
      <template #content>
        <el-form ref="addStudyDept" :rules="addStudyDeptRules" inline :model="addStudyDeptForm" label-position="right" label-width="120px">
          <div>
            <el-form-item style="display: flex !important" prop="deptType" label="科室类型：">
              <el-select style="width: 100%" v-model="addStudyDeptForm.deptType" placeholder="请选择" @change="addTrainChange">
                <el-option v-for="item in dict.type.train_type" :key="item.value" :label="item.label" :value="item.value"> </el-option>
              </el-select>
            </el-form-item>
          </div>
          <div>
            <el-form-item style="display: flex !important" prop="deptId" label="进修科室：">
              <el-select v-model="addStudyDeptForm.deptId" filterable placeholder="请选择" @change="addDeptChange" style="width: 100%">
                <el-option v-for="item in deptList" :key="item.deptId" :label="item.deptName" :value="item.deptId"></el-option>
              </el-select>
            </el-form-item>
          </div>
          <div>
            <el-form-item style="display: flex !important" prop="beginDate" label="开始日期：">
              <el-date-picker
                v-model="addStudyDeptForm.beginDate"
                @change="addDateChange"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd"
                type="date"
                style="width: 100%"
                :clearable="false"
                :picker-options="addBeginDisabled"
              ></el-date-picker>
            </el-form-item>
          </div>
          <div>
            <el-form-item style="display: flex !important" prop="trainDuration" label="进修时长：" >
              <el-select v-model="addStudyDeptForm.trainDuration" placeholder="请选择"  style="width: 100%">
                <el-option v-for="(item, index) in ['1', '2',  '4']" :key="index"
                  :label="item + '周'" :value="item">
                </el-option>
              </el-select>
            </el-form-item>
          </div>
        </el-form>
      </template>
    </Modal>
    <!-- 修改进修科室 -->
    <Modal :showState="modifyStudyDeptState" @cancel="modifyStudyDeptCancel" title="修改" @confirm="modifyStudyDeptConfirm">
      <template #content>
        <el-form ref="modifyStudyDept" :rules="modifyStudyDeptRules" inline :model="modifyStudyDeptForm" label-position="right" label-width="120px">
          <div>
            <el-form-item style="display: flex !important" prop="deptType" label="科室类型：">
              <el-select style="width: 100%" v-model="modifyStudyDeptForm.deptType" placeholder="请选择">
                <el-option v-for="item in dict.type.train_type" :key="item.value" :label="item.label" :value="item.value"> </el-option>
              </el-select>
            </el-form-item>
          </div>
          <div>
            <el-form-item style="display: flex !important" prop="deptId" label="进修科室：">
              <el-select v-model="modifyStudyDeptForm.deptId" filterable placeholder="请选择" style="width: 100%">
                <el-option v-for="item in deptList" :key="item.deptId" :label="item.deptName" :value="item.deptId"></el-option>
              </el-select>
            </el-form-item>
          </div>
          <div>
            <el-form-item style="display: flex !important" prop="beginDate" label="开始日期：">
              <el-date-picker
                v-model="modifyStudyDeptForm.beginDate"
                @change="addDateChange"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd"
                type="date"
                style="width: 100%"
                :clearable="false"
                :picker-options="addBeginDisabled"
              ></el-date-picker>
            </el-form-item>
          </div>
          <div>
            <el-form-item style="display: flex !important" prop="trainDuration" label="进修时长："  >
             <el-select v-model="modifyStudyDeptForm.trainDuration" placeholder="请选择" style="width: 100%">
                <el-option v-for="(item, index) in ['1', '2',  '4']" :key="index"
                  :label="item + '周'" :value="item">
                </el-option>
              </el-select>
            </el-form-item>
          </div>
        </el-form>
      </template>
    </Modal>
  </div>
</template>
<script>
import { getToken } from '@/utils/auth'
import { stagingApplyStorageAdmin, getDeptList, adminDirectionList, nurseDirectionList } from '@/utils/api'
import Modal from '@/views/components/modal.vue'
import dayjs from 'dayjs'
import { v4 as uuidv4 } from 'uuid'
export default {
  dicts: ['special_items', 'train_type'],
  components: {
    Modal
  },
  data() {
    return {
      form: {
        trainType: this.$route.query.type,
        // 申请信息
        applyBasic: {
          specialItemsOther: ''
        },
        // 进修科室
        applyDeptList: [],
        // 附件
        applyAttList: []
      },
      isSpecialItems: 0,
      headers: {
        Authorization: 'Bearer ' + getToken()
      },
      // 新增进修科室显示状态
      addStudyDeptState: false,
      // 新增进修科室表单
      addStudyDeptForm: {
        beginDate: '',
        trainDuration: ''
      },
      // 新增进修科室表单校验
      addStudyDeptRules: {
        beginDate: [{ required: true, trigger: 'change', message: '开始日期不能为空' }],
        endDate: [{ required: true, trigger: 'change', message: '结束日期不能为空' }],
        deptId: [{ required: true, trigger: 'change', message: '进修科室不能为空' }],
        trainDuration: [{ required: true, trigger: 'change', message: '进修时长不能为空' }]
      },
      // 修改进修科室显示状态
      modifyStudyDeptState: false,
      // 修改进修科室表单
      modifyStudyDeptForm: {},
      // 修改进修科室表单校验
      modifyStudyDeptRules: {
        beginDate: [{ required: true, trigger: 'change', message: '开始日期不能为空' }],
        endDate: [{ required: true, trigger: 'change', message: '结束日期不能为空' }],
        deptId: [{ required: true, trigger: 'change', message: '进修科室不能为空' }],
        trainDuration: [{ required: true, trigger: 'change', message: '进修时长不能为空' }]
      },
      // 科室列表
      deptList: [],
      deptList1: [],
      deptList2: [],
      deptList3: [],
      // 上传文件类型
      uploadType: '',
      rules: {
        trainRequest: {
          required: true,
          trigger: 'blur',
          message: '进修内容与目标不能为空'
        }
      }
    }
  },
  computed: {
    addBeginDisabled() {
      return {
        disabledDate(time) {
          const today = dayjs()
          const d = dayjs(time)
          
          // 获取当前日期所在周的周一
          const currentWeekMonday = today.startOf('week').add(1, 'day') // dayjs中周日是0，周一是1
          // 获取下下周的周一
          const weekAfterNextMonday = currentWeekMonday.add(2, 'week')
          
          // 只允许下下周及之后的日期
          if (d.isBefore(weekAfterNextMonday)) {
            return true
          }
          
          // 只允许周一
          if (d.day() !== 1) {
            return true
          }

          return false
        }
      }
    }
  },
  created() {
    this.form = this.$parent.administrativeForm
    this.form.applyBasic.specialItems ? (this.isSpecialItems = 1) : (this.isSpecialItems = 0)
    this.form.applyDeptList.forEach(item => {
      item.uuid = uuidv4()
    })
    this._getDeptList()
  },
  mounted() {},
  methods: {
    _getDeptList() {
      // 获取科室列表
      getDeptList({ deptTrainType: '0' }).then(res => {
        this.deptList1 = res.data
      })
      nurseDirectionList({ pageSize: 9999 })
        .then(res => {
          this.deptList2 = res.rows
        })
        .catch(err => {
          console.log(err)
        })
      adminDirectionList({
        pageSize: 9999
      }).then(res => {
        this.deptList3 = res.rows
      })
    },
    addDeptChange(val) {
      this.deptList.find(item => {
        if (item.deptId == val) {
          this.addStudyDeptForm.deptName = item.deptName
        }
      })
    },
    addTrainChange(val) {
      if (val == 0) {
        this.deptList = this.deptList1
      } else if (val == 1) {
        this.deptList = this.deptList2
      } else {
        this.deptList = this.deptList3
      }
    },
    // 新增响应进修时间
    addDateChange(date) {},
    modifyDateChange() {},
    // 打开新增进修科室
    showAddStudyDept() {
      this.addStudyDeptState = true
    },
    // 确认新增进修科室
    addStudyDeptConfirm() {
      this.$refs.addStudyDept.validate(valid => {
        if (valid) {
          // 新增并关闭弹窗
          let obj = {
            ...this.addStudyDeptForm,
            uuid: uuidv4()
          }
          this.form.applyDeptList.push(JSON.parse(JSON.stringify(obj)))
          this.addStudyDeptCancel()
        }
      })
    },
    // 关闭新增进修科室
    addStudyDeptCancel() {
      this.addStudyDeptForm = {}
      this.addStudyDeptState = false
      this.$refs.addStudyDept.resetFields()
    },
    // 删除进修科室
    removeStudyDept(obj) {
      let that = this
      that
        .$confirm('此操作将永久删除该记录, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
        .then(() => {
          that.form.applyDeptList.forEach((item, index) => {
            if (item.uuid == obj.uuid) {
              that.form.applyDeptList.splice(index, 1)
            }
          })
        })
    },
    // 打开修改进修科室
    showModifyStudyDept(obj) {
      this.modifyStudyDeptState = true
      let form = JSON.parse(JSON.stringify(obj))
      this.modifyStudyDeptForm = form
    },
    // 修改进修科室确认
    modifyStudyDeptConfirm() {
      let that = this
      this.form.applyDeptList.forEach((item, index) => {
        if (item.uuid == that.modifyStudyDeptForm.uuid) {
          let obj = {
            ...that.modifyStudyDeptForm
          }
          that.$set(that.form.applyDeptList, index, obj)
          that.modifyStudyDeptCancel()
        }
      })
    },
    // 关闭修改进修科室
    modifyStudyDeptCancel() {
      this.modifyStudyDeptState = false
    },
    goPage(val) {
      stagingApplyStorageAdmin(this.form).then(res => {
        if (res.code == 200) {
          this.$message.success('暂存信息成功')
          this.$parent.active = val
        }
      })
    },
    // 保存此页信息
    staging() {
      stagingApplyStorageAdmin(this.form).then(res => {
        if (res.code == 200) {
          this.$message.success('暂存信息成功')
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
::v-deep .title .el-form-item__label {
  font-size: 22px;
  color: #333;
  padding: 0;
}

::v-deep .el-form-item__content {
  flex-grow: 1;
}

.el-button--primary {
  padding: 0;
}

.backIndex:hover {
  cursor: pointer;
}

.formTitle {
  margin: 50px 0px 30px 240px;
}

.step {
  margin-bottom: 50px;
}

::v-deep .el-textarea__inner {
  height: 95px;
  font-size: 18px;
}

::v-deep.form {
  margin-bottom: 47px;
  overflow: hidden;

  .footer {
    .a {
      display: inline-block;
      width: 40px;
      line-height: 36px;
      text-align: center;
      border-radius: 5px;
      height: 40px;
      color: #333;
      border: #999999 solid 2px;
      margin-left: 30px;

      &:hover {
        border-color: #2d53c8;
      }
    }

    & > .a:last-child {
      width: 110px;
    }

    & > .active {
      border-color: #2d53c8;
    }
  }
}
</style>
